<!-- desktop template -->
<div class="single-offer mar-top-15 mar-bot-40 text-left relative d-flex flex-column" *ngIf="!isMobile">
    <a (click)="clickMerchant($event, offer, 'tile_click')" [routerLink]="detailsUrlPath"

        class="offer-img block">
        <img class="img-fluid " [default]="'https://images.poshvine.com/b/default-thumbnail-image.jpg'"
            [src]="offer.attributes?.image_url">
    </a>
    <a (click)="clickMerchant($event, offer, 'tile_click')" [routerLink]="detailsUrlPath"

    class="merchant-logo absolute block">
        <img class="img-fluid" [default]="'https://images.poshvine.com/b/default-thumbnail-square.jpg'"
            [src]="offer.merchant.attributes?.logo_url">
    </a>
    <div class="offer-rtxt-data pad-top-35 block">
        <div class="w100">
            <a (click)="clickMerchant($event, offer, 'tile_click')" [routerLink]="detailsUrlPath"
            class="offer-title ellipsis f600 fnt-17 c0E202E block" [innerHtml] = "offer.merchant.attributes?.name"></a>
            <a (click)="clickMerchant($event, offer, 'tile_click')" [routerLink]="detailsUrlPath"
            class="desc-box h-3rem block">
                <div class="offer-desc c3A4149 fnt-13 pad-top-6 mar-bot-3 f500 ">
                    {{offer.attributes?.title}}
                  </div>
                <!-- <ng-template #taxesTemplate>
                  <div *ngFor="let offer of merchant?.offer.data;let j=index"
                    class="d-flex align-center justify-content-between">
                    <span>
                      <svg class="mar-right-5 mar-top-3 tick-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" width="352.62px" height="352.62px" viewBox="0 0 352.62 352.62" style="enable-background:new 0 0 352.62 352.62;" xml:space="preserve"><g><path d="M337.222,22.952c-15.912-8.568-33.66,7.956-44.064,17.748c-23.867,23.256-44.063,50.184-66.708,74.664   c-25.092,26.928-48.348,53.856-74.052,80.173c-14.688,14.688-30.6,30.6-40.392,48.96c-22.032-21.421-41.004-44.677-65.484-63.648   c-17.748-13.464-47.124-23.256-46.512,9.18c1.224,42.229,38.556,87.517,66.096,116.28c11.628,12.24,26.928,25.092,44.676,25.704   c21.42,1.224,43.452-24.48,56.304-38.556c22.645-24.48,41.005-52.021,61.812-77.112c26.928-33.048,54.468-65.485,80.784-99.145   C326.206,96.392,378.226,44.983,337.222,22.952z M26.937,187.581c-0.612,0-1.224,0-2.448,0.611   c-2.448-0.611-4.284-1.224-6.732-2.448l0,0C19.593,184.52,22.653,185.132,26.937,187.581z"/></g></svg>
                      <span>{{offer.attributes.title}}</span>
                    </span>
                  </div>
                </ng-template> -->

            </a>
            <div class="claim-block flex space-between align-center mar-bot-12 mt-3 flex-column relative">
              <button i18n id="gtm-offer-card-claim-btn" class="cfff f500 claim-btn fnt-16 w-100" (click)="emitRedeemOffer(offer, $event);">Claim offer</button>
                  <!-- <div *ngIf="(merchant?.offer?.claimable && merchant?.offer?.claimable_by_country && merchant?.offer?.eligible) || !_authService.isAuthenticated()">
                      <button id="gtm-offer-card-claim-btn" class="cfff f500 claim-btn fnt-16 " (click)="emitRedeemOffer(merchant, $event);">Claim offer</button>
                  </div>
                  <div *ngIf="!merchant?.offer?.claimable && merchant?.offer?.eligible && _authService.isAuthenticated()">
                      <button class="cfff  cursor-default claimed-btn fnt-16  capitalize">Claimed</button>
                  </div>
                  <div *ngIf="(!merchant?.offer?.claimable_by_country) && !(!merchant?.offer?.claimable && merchant?.offer?.eligible) && _authService.isAuthenticated()">
                      <button class="cfff  cursor-default claimed-btn fnt-16  capitalize">Unavilable</button>
                  </div> -->

                  <button i18n class="ga-know-more know-more-cta absolute mt-3 w-100 text-white" (click)="clickMerchant($event, offer, 'Know more')">
                    Know more
                  </button>
            </div>
          </div>
    </div>
</div>

<!-- mobile template -->
<a (click)="clickMerchant($event, offer, 'tile_click')"

class="mobile-single-offer mar-top-15 text-left relative w100 d-flex flex-column h-100" *ngIf="isMobile">
    <div class="offer-img">
        <img class="img-fluid" [default]="'https://images.poshvine.com/b/default-thumbnail-image.jpg'"
            [src]="offer.attributes?.image_url">
    </div>
    <div class="merchant-logo absolute">
        <img class="img-fluid" [default]="'https://images.poshvine.com/b/default-thumbnail-square.jpg'"
            [src]="offer.merchant.attributes?.logo_url">
    </div>
    <div class="offer-rtxt-data h-100">
        <div class="offer-title ellipsis f500" [ngClass]="isMobile ? 'fnt-12' : 'text-lg'">{{offer.merchant.attributes.name}}</div>
        <div class="desc-box h-3rem">
            <div class="offer-desc c3A4149 pad-top-6 f4300 mar-bot-3 fnt-13 f500">
              {{offer.attributes?.title || offer.attributes?.title}}
            </div>
                <!-- <ng-template #taxesTemplate>
                  <div *ngFor="let offer of merchant?.offer.data;let j=index"
                    class="d-flex align-center justify-content-between">
                    <span>
                      <svg class="mar-right-5 mar-top-3 tick-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" width="352.62px" height="352.62px" viewBox="0 0 352.62 352.62" style="enable-background:new 0 0 352.62 352.62;" xml:space="preserve"><g><path d="M337.222,22.952c-15.912-8.568-33.66,7.956-44.064,17.748c-23.867,23.256-44.063,50.184-66.708,74.664   c-25.092,26.928-48.348,53.856-74.052,80.173c-14.688,14.688-30.6,30.6-40.392,48.96c-22.032-21.421-41.004-44.677-65.484-63.648   c-17.748-13.464-47.124-23.256-46.512,9.18c1.224,42.229,38.556,87.517,66.096,116.28c11.628,12.24,26.928,25.092,44.676,25.704   c21.42,1.224,43.452-24.48,56.304-38.556c22.645-24.48,41.005-52.021,61.812-77.112c26.928-33.048,54.468-65.485,80.784-99.145   C326.206,96.392,378.226,44.983,337.222,22.952z M26.937,187.581c-0.612,0-1.224,0-2.448,0.611   c-2.448-0.611-4.284-1.224-6.732-2.448l0,0C19.593,184.52,22.653,185.132,26.937,187.581z"/></g></svg>
                      <span>{{offer.attributes.title}}</span>
                    </span>
                  </div>
                </ng-template> -->
        </div>
        <div class="claim-block flex space-between align-center mar-top-15 relative">
          <button i18n id="gtm-offer-card-claim-btn" class="cfff f500 claim-btn fnt-16 w-100" (click)="emitRedeemOffer(offer, $event);">Claim offer</button>
            <!-- <ng-container  *ngIf="(merchant?.offer?.claimable && merchant?.offer?.claimable_by_country && merchant?.offer?.eligible) || !_authService.isAuthenticated()">
                <button id="gtm-offer-card-claim-btn" class="cfff f500 claim-btn fnt-16 " (click)="emitRedeemOffer(merchant, $event);">Claim offer</button>
            </ng-container>
            <ng-container *ngIf="!merchant?.offer?.claimable && merchant?.offer?.eligible && _authService.isAuthenticated()">
                <button class="cfff  cursor-default claimed-btn fnt-16  capitalize">Claimed</button>
            </ng-container>
            <ng-container *ngIf="(!merchant?.offer?.claimable_by_country) && !(!merchant?.offer?.claimable && merchant?.offer?.eligible) && _authService.isAuthenticated()">
                <button class="cfff  cursor-default claimed-btn fnt-16  capitalize">Unavilable</button>
            </ng-container> -->
            <button i18n class="ga-know-more know-more-cta absolute mar-top-10 w-12 text-white" (click)="clickMerchant($event, offer, 'Know more')">
              Know more
            </button>
        </div>

    </div>
</a>
